import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Icon } from "@iconify/react";
import { Box } from "@shopify/polaris";

const Iconify = forwardRef(({ icon, style, ...other }, ref) => {
  return (
    <Box ref={ref} as="span" style={{ display: "inline-flex", ...style }} {...other}>
      <Icon icon={icon} style={style} />
    </Box>
  );
});

Iconify.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  style: PropTypes.object,
};

export default Iconify;
